import { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function VideoExpansionPackModal({
  show,
  handleClose,
  data,
  handleAccept,
}: {
  show: boolean;
  handleClose: () => void;
  data: any;
  handleAccept: (cartServiceOptionId: number, selectedQuantity: number, options: any) => void;
}) {
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  if (data === null) {
    return null;
  }

  return (
    <Modal show={show} onHide={handleClose} size='lg' contentClassName='no-radius'>
      <Modal.Body className='p-0 no-radius'>
        <Container className='p-0 overflow-scroll mh-vh-75'>
          <Row className='g-0'>
            <Col xs={12} md={6} className='p-4'>
              <img
                style={{ height: "100%", width: "100%" }}
                src='https://dc84iurnf722p.cloudfront.net/ProductCatalog/prod/ReadyHomeAlarm_1200x795-4.svg'
                alt=''
              />
            </Col>
            <Col xs={12} md={6} className='p-2'>
              <div className='d-flex justify-content-center flex-column p-4'>
                <div className='fw-bold mb-4'>
                  This video expansion pack supports more than {data.thresholdQuantity} cameras allowing {data.numberOfClips}. There is a{" "}
                  {data.monthlyCharge} monthly service cost for the video expansion pack.
                </div>
                <div className='mb-4 text-center'>
                  <Button
                    disabled={buttonsDisabled}
                    className='me-2 bg-primary text-white me-4'
                    variant=''
                    onClick={() => {
                      setButtonsDisabled(true);
                      handleAccept(data.cartServiceOptionId, data.selectedQuantity, {
                        afterFinally: () => {
                          setButtonsDisabled(false);
                        },
                      });
                    }}>
                    Yes, I accept
                  </Button>
                  <Button disabled={buttonsDisabled} variant='outline-secondary ms-4' onClick={handleClose}>
                    No Thanks
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default VideoExpansionPackModal;
